import { Injectable , inject} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AppConfigService } from 'app/core/config/app-config.service';

export interface Win {
  id: number;
  date: string;
  message_type: 'student_win' | 'course_completion_result';
  subject: string;
  message: string;
  course_title?: string | null;
  step_title?: string | null;
  student_course_id?: number | null;
  student_course_step_id?: number | null;
}

export interface SaveWinPayload {
  message: string;
  subject?: string;
  student_course_id?: number;
  student_course_step_id?: number;
  message_type?: 'student_win' | 'course_completion_result';
}

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' }),
};

@Injectable({ providedIn: 'root' })
export class WinService {
  constructor(private http: HttpClient, readonly appConfig: AppConfigService) {}

  getWins(studentId: number): Observable<Win[]> {
    return this.http
      .get<any>(`${this.appConfig.get('serverUrl')}/v1/students/${studentId}/wins`, httpOptions)
      .pipe(
        map((r) => (Array.isArray(r?.data) ? r.data : []) as Win[]),
        catchError(() => of([])),
      );
  }

  saveWin(studentId: number, payload: SaveWinPayload): Observable<Win> {
    return this.http
      .post<any>(`${this.appConfig.get('serverUrl')}/v1/students/${studentId}/wins`, JSON.stringify(payload), httpOptions)
      .pipe(
        map((r) => r?.data as Win),
        catchError((err) => throwError(() => err?.error?.error || err?.message || 'Failed to save win')),
      );
  }
}
